import React, { useEffect } from 'react';
import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from 'polotno';
import { PagesTimeline } from 'polotno/pages-timeline';
import { ZoomButtons } from 'polotno/toolbar/zoom-buttons';
import { SidePanel } from 'polotno/side-panel';
import { Workspace } from 'polotno/canvas/workspace';
import '@blueprintjs/core/lib/css/blueprint.css';
import { createStore } from 'polotno/model/store';
import { sections } from './side-panel';
import Topbar from '../Topbar/Topbar';
import './editor.css';
import { useSelector } from 'react-redux';
import Toolbar from 'polotno/toolbar/toolbar';
import { setRemoveBackgroundEnabled } from 'polotno/config';

// Enable background removal feature
setRemoveBackgroundEnabled(true);

// Create store instance (singleton)
const store = createStore({
  key: process.env.REACT_APP_POLOTNO_API_KEY,
  showCredit: true,
});

export const Editor = ({ templateId, creativeId }) => {
  const { loadStore } = useSelector((state) => state.preferences);


  useEffect(() => {
    if (loadStore) {
      store.loadJSON(loadStore, true);
    }
  }, [loadStore]);

  return (
    <div>
      <Topbar store={store} templateId={templateId} creativeId={creativeId} />
      <div>
        <PolotnoContainer style={{ width: '100vw', height: 'calc(100vh - 64px)' }}>
          <SidePanelWrap>
            <SidePanel store={store} sections={sections} defaultSection='feed' />
          </SidePanelWrap>
          <WorkspaceWrap>
            <Toolbar store={store} />
            <Workspace store={store} layout="horizontal" />
            <ZoomButtons store={store} />
            <PagesTimeline store={store} />
          </WorkspaceWrap>
        </PolotnoContainer>
      </div>
    </div>
  );
};

export default Editor;